import { Box, TablePagination } from '@mui/material'
import React, { useState } from 'react'
import IconTooltipButton from '../../button/IconTooltipButton'
import SettingDialog from './SettingDialog'

const Settings = ({ 
  id,
  actionsSetting,
  totalRows, 
  page, 
  handleChangePage, 
  rowsPerPage, 
  handleChangeRowsPerPage,
  columns,
  handleShowColumns
}) => {
  const [showSetting, setShowSetting] = useState(false)

  return (
    <Box className='flex items-center justify-between gap-4 sticky top-0px left-0 bg-background z-10 h-14'>
      <div className='flex flex-wrap items-center gap-2'>
        {actionsSetting}
      </div>
      <div className='flex justify-end'>
        <TablePagination
          size="small"
          component='div'
          count={totalRows}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 25, 50, 100]}
          rowsPerPage={rowsPerPage}            
        /> 
        <div className='flex items-center'>
          <IconTooltipButton 
            id={`settings-button-${id}`}
            title='Settings' 
            icon="ellipsis-h"
            className='text-xl'
            color='primary'
            onClick={() => setShowSetting(!showSetting)}
          />
        </div>       
      </div>
      { showSetting && 
        <SettingDialog
          id={id}
          show={showSetting}
          onClose={() => setShowSetting(false)}
          columns={columns}
          handleShowColumns={handleShowColumns}
        /> 
      }
    </Box>
  )
}

export default Settings